import type { DashboardContainer } from '@ctp/shared';

/** Teilt die Dashboard-Container in Premium (plan==='premium') und Standard auf (D7). */
export function partitionByPlan(list: DashboardContainer[]): {
  premium: DashboardContainer[];
  standard: DashboardContainer[];
} {
  const premium: DashboardContainer[] = [];
  const standard: DashboardContainer[] = [];
  for (const c of list) (c.plan === 'premium' ? premium : standard).push(c);
  return { premium, standard };
}

/** Snapshot der lastRefreshedAt-Werte (für die Flash-Erkennung zwischen zwei Polls). */
export function refreshedAtMap(list: DashboardContainer[]): Map<string, string | null> {
  return new Map(list.map((c) => [c.trackedContainerId, c.lastRefreshedAt ?? null]));
}

/**
 * Premium-Container, deren `lastRefreshedAt` gegenüber dem vorigen Stand VORGERÜCKT ist (D7).
 * Nur Premium-Zeilen flashen; neu hinzugekommene Container (nicht im prev-Snapshot) flashen NICHT
 * (sonst würde das Erst-Laden alles aufleuchten lassen).
 */
export function detectFlashedIds(
  prev: Map<string, string | null>,
  next: DashboardContainer[],
): string[] {
  const out: string[] = [];
  for (const c of next) {
    if (c.plan !== 'premium') continue;
    if (!prev.has(c.trackedContainerId)) continue;
    const before = prev.get(c.trackedContainerId) ?? '';
    const now = c.lastRefreshedAt ?? '';
    if (now > before) out.push(c.trackedContainerId);
  }
  return out;
}

/** Abschlussdatum einer Archiv-Zeile (EPIC Q): datengetriebener Abschluss vor manuellem Archiv. */
export function completedAtOf(c: DashboardContainer): string | null {
  return c.journeyCompletedAt ?? c.archivedAt ?? null;
}

/**
 * i18n-Key des Abschluss-Grunds für den Badge-Tooltip (White-Label, D6 — kein Anbietername):
 * 'empty_return' → Leerrückgabe erfolgt · 'vizion_auto_unsubscribe' → neue Reise erkannt ·
 * manuell archiviert (nur archivedAt) → manuell abgeschlossen.
 */
export function completionReasonKey(c: DashboardContainer): string {
  if (c.completionReason === 'empty_return') return 'archive.reason.emptyReturn';
  if (c.completionReason === 'vizion_auto_unsubscribe') return 'archive.reason.newJourney';
  return 'archive.reason.manual';
}

export type DndTone = 'ok' | 'warn' | 'breach';

/** Ampel-Ton aus verbleibenden Frei-Tagen: <0 rot, ≤warnAt gelb, sonst grün. */
export function dndTone(daysLeft: number, warnAtDays = 3): DndTone {
  if (daysLeft < 0) return 'breach';
  if (daysLeft <= warnAtDays) return 'warn';
  return 'ok';
}
